<template>
  <div class="d-flex user-pill overflow-hidden">
    <user-short class="pl-2" :user-id="+item.id === -1 ? '' : item.id" length="18"></user-short>
    <span class="user-text text-truncate" :title="item.label" v-no-capture>{{ item.label }}</span>
  </div>
</template>

<script>
import UserShort from '@/components/UserShort'

/**
 * This provides the template for the selected items in user filter
 */
export default {
  name: 'UserPillTemplate',
  props: ['item'],
  components: {
    UserShort
  }
}
</script>

<style lang="scss" scoped>
.user-pill .user-short-container {
  padding: 0 5px 0 4px !important;
}
</style>
